import produce from 'immer'
import { assign, map, omit } from 'lodash'

import {
  COMMON_FETCH_EVENTS,
  COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES,
} from '../action-types'
import { EVENTS_INITIAL_STATE } from '../initial-states'

const eventsReducer = (state = EVENTS_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_EVENTS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchEventsLoading: true,
          fetchEventsError: undefined,
          data: undefined,
        }),
      )

    case COMMON_FETCH_EVENTS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchEventsLoading: false,
          fetchEventsError: undefined,
          eventsData: {
            ...action.payload.data.events,
            results: map(
              action.payload.data.events.results,
              ({ original, changes, ...rest }) => ({
                ...rest,
                original: JSON.parse(original),
                changes: JSON.parse(changes),
              }),
            ),
          },
        }),
      )

    case COMMON_FETCH_EVENTS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchEventsLoading: false,
          fetchEventsError: action.error.message,
          eventsData: undefined,
        }),
      )

    case COMMON_FETCH_EVENTS.CLEANUP:
      return produce(state, nextState =>
        assign(
          nextState,
          omit(EVENTS_INITIAL_STATE, 'latestEventByEntityTypesData'),
        ),
      )

    case COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLatestEventByEntityTypesLoading: true,
          fetchFetchLatestEventByEntityTypesError: undefined,
          latestEventByEntityTypesData: undefined,
        }),
      )

    case COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLatestEventByEntityTypesLoading: false,
          fetchFetchLatestEventByEntityTypesError: undefined,
          latestEventByEntityTypesData:
            action.payload.data.latestEventByEntityTypes,
        }),
      )

    case COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLatestEventByEntityTypesLoading: false,
          fetchFetchLatestEventByEntityTypesError: action.error.message,
          latestEventByEntityTypesData: undefined,
        }),
      )

    case COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES.CLEANUP:
      return { ...EVENTS_INITIAL_STATE }

    default:
      return state
  }
}

export default eventsReducer
